"use strict";
export function checkPermission(availablePermissions, requiredPermissions) {
  const shellPermissionsSet = new Set(availablePermissions);
  if (typeof requiredPermissions === "string")
    return shellPermissionsSet.has(requiredPermissions);
  for (const permission of requiredPermissions) {
    if (!permission)
      continue;
    if (permission.length === 0)
      continue;
    if (typeof permission === "string") {
      if (!shellPermissionsSet.has(permission)) return false;
      continue;
    }
    if (!permission.some((optionalPermission) => shellPermissionsSet.has(optionalPermission))) return false;
  }
  return true;
}
